import { render, staticRenderFns } from "./WordCreate.vue?vue&type=template&id=1ab4d4a5"
import script from "./WordCreate.vue?vue&type=script&lang=js"
export * from "./WordCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports